import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceComplianceMode } from '@features/invoices/hooks/useInvoiceComplianceMode'

import { useMissingCustomerDetailsForm } from '../../../../../../contexts/missingCustomerDetailsFormContext'

export const CustomerCompanyName = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCustomerDetailsForm: { FormItem },
  } = useMissingCustomerDetailsForm()
  const { isFrenchComplianceMode } = useInvoiceComplianceMode()

  const isCompanyNameReadOnly = !isFrenchComplianceMode

  return (
    <FormItem
      label={t('external_invoices.missing_customer_compliance_details.modal.form.field.customer_company_name.label')}
      name="companyName"
      render={({ field }) => {
        return <Input {...field} disabled={isCompanyNameReadOnly} size="sm" />
      }}
    />
  )
}
